/**
 * Global script
 *
 * @author HammersportMarketing
 */
import { checkWPAdminBar } from "./functions";

$(function () {
  if ($(window).width() <= 768) {
    $(".call-to-action").removeClass("orange-variant");
  }
});

$(window).on("resize", function () {
  if ($(window).width() <= 768) {
    $(".call-to-action").removeClass("orange-variant");
  } else {
    $(".call-to-action").addClass("orange-variant");
  }
});

$(window).on("scroll", function () {
  checkWPAdminBar();
});

$(".share-link").on("click", function (e) {
  e.preventDefault();
  window.open($(this).attr("href"), "Share", "width=600,height=400");
});
